<div class="stepper-container" *ngIf="isDataReady">
  <div class="header">
    <img
      src="../../../../assets/Logos/zentra_logo-removebg-preview 1.png"
      alt="zentra green logo"
      width="50"
      height="50"
    />
    <h1>Zentra Subscription Configuration</h1>
  </div>
  <hr />
  <mat-horizontal-stepper [linear]="isLinear" #stepper>
    <ng-template #loading>
      <div class="loading-container">
        <mat-spinner diameter="50"></mat-spinner>
        <p>Loading data, please wait...</p>
      </div>
    </ng-template>
    <!-- Step 1: Select Product -->
    <mat-step [stepControl]="firstFormGroup">
      <form [formGroup]="firstFormGroup" (click)="markAllControlsTouched()">
        <ng-template matStepLabel>Products</ng-template>
        <div><h2>Select A Product</h2></div>
        <div class="products">
          <div class="product-cards">
            <mat-card
              *ngFor="let product of products"
              class="product-card"
              [ngClass]="{
                selected: selectedProduct?.product?.id === product.product.id
              }"
              (click)="selectProductInt(product)"
            >
              <mat-card-header>
                <mat-card-title>{{ product.product.name }}</mat-card-title>
                <mat-card-subtitle>{{
                  product.product.productFamily.name
                }}</mat-card-subtitle>
              </mat-card-header>
              <mat-card-content>
                <p>
                  Description:
                  {{
                    product.product.description || "No description available."
                  }}
                </p>
                <div
                  *ngIf="
                    selectedProduct?.product?.id === product.product.id &&
                    selectedProductHasSiteVariants
                  "
                  class="existing-site-section"
                  (click)="$event.stopPropagation()"
                >
                  <p class="existing-site-label">
                    Is this an existing Zentra Connect site?
                  </p>
                  <mat-radio-group
                    [value]="isExistingZentraConnectSite"
                    (change)="onExistingZentraConnectSiteChange($event.value)"
                  >
                    <mat-radio-button value="YES">Yes</mat-radio-button>
                    <mat-radio-button value="NO">No</mat-radio-button>
                  </mat-radio-group>
                  <div
                    *ngIf="isExistingZentraConnectSite === 'YES'"
                    class="po-number-section"
                  >
                    <mat-form-field
                      appearance="outline"
                      class="po-number-field"
                    >
                      <mat-label>PO Number</mat-label>
                      <input
                        matInput
                        formControlName="poNumber"
                        placeholder="Enter PO number"
                      />
                      <mat-error
                        *ngIf="
                          firstFormGroup.get('poNumber')?.hasError('required')
                        "
                      >
                        PO Number is required
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
              </mat-card-content>
            </mat-card>
            <ng-template #noProducts>
              <p>No products available.</p>
            </ng-template>
          </div>
        </div>
      </form>
    </mat-step>
    <!-- Step 2: Customer Info -->
    <mat-step [stepControl]="secondFormGroup">
      <form (click)="markAllControlsTouched()" [formGroup]="secondFormGroup">
        <ng-template matStepLabel>Configuration</ng-template>
        <div><h2>Configure Subscription</h2></div>
        <div class="ci-inputs">
          <div class="plan-section">
            <div class="section-header">
              <mat-icon>dashboard_customize</mat-icon>
              <h3>
                Plan:
                {{ selectedProduct?.product?.name || "No product selected" }}
              </h3>
            </div>
            <div class="plan-details">
              <div class="components-container" formArrayName="components">
                <div
                  class="component-card"
                  *ngFor="
                    let componentControl of components.controls;
                    let i = index
                  "
                  [formGroupName]="i"
                >
                  <!-- Mandatory (locked) component layout -->
                  <ng-container *ngIf="isComponentMandatory(i)">
                    <div class="component-card-header">
                      <h3>Component Details</h3>
                      <div class="mandatory-badge">
                        <mat-icon>lock</mat-icon>
                        <span>Included — cannot be removed</span>
                      </div>
                    </div>
                    <mat-form-field class="full-width">
                      <mat-label>Component</mat-label>
                      <input
                        matInput
                        readonly
                        [value]="mandatoryComponents[i]?.name || ''"
                      />
                    </mat-form-field>
                    <mat-form-field class="full-width">
                      <mat-label>Quantity</mat-label>
                      <input
                        *ngIf="!isMandatoryQtyEditable(i)"
                        matInput
                        type="number"
                        readonly
                        value="1"
                      />
                      <input
                        *ngIf="isMandatoryQtyEditable(i)"
                        matInput
                        type="number"
                        formControlName="allocatedQuantity"
                        placeholder="Enter quantity"
                        required
                      />
                      <mat-error
                        *ngIf="
                          componentControl
                            .get('allocatedQuantity')
                            ?.hasError('min')
                        "
                      >
                        Quantity must be at least 1.
                      </mat-error>
                      <mat-error
                        *ngIf="
                          componentControl
                            .get('allocatedQuantity')
                            ?.hasError('notInteger')
                        "
                      >
                        Quantity must be a whole number.
                      </mat-error>
                    </mat-form-field>
                    <ng-container *ngIf="connectComponentService.isConnectComponent(componentControl)">
                      <mat-form-field class="full-width">
                        <mat-label>Number of Units</mat-label>
                        <input
                          matInput
                          type="number"
                          min="0"
                          formControlName="numberOfUnits"
                          required
                        />
                        <mat-error
                          *ngIf="
                            componentControl
                              .get('numberOfUnits')
                              ?.hasError('min')
                          "
                        >
                          Number of Units cannot be negative.
                        </mat-error>
                      </mat-form-field>
                      <mat-form-field class="full-width">
                        <mat-label>Number of Perimeter/Amenity</mat-label>
                        <input
                          matInput
                          type="number"
                          min="0"
                          formControlName="numberOfPerimeterAmenity"
                          required
                        />
                        <mat-error
                          *ngIf="
                            componentControl
                              .get('numberOfPerimeterAmenity')
                              ?.hasError('min')
                          "
                        >
                          Number of Perimeter/Amenity cannot be negative.
                        </mat-error>
                      </mat-form-field>
                    </ng-container>
                    <div class="component-price">
                      <h4>
                        Price per Unit:
                        {{ mandatoryComponents[i]?.prices?.[0]?.formattedUnitPrice ?? '' }}
                      </h4>
                    </div>
                    <div class="action-buttons">
                      <button
                        mat-button
                        color="primary"
                        (click)="addComponent()"
                      >
                        <mat-icon>add</mat-icon>
                        Add Component
                      </button>
                    </div>
                  </ng-container>

                  <!-- Optional (editable) component layout -->
                  <ng-container *ngIf="!isComponentMandatory(i)">
                    <h3>Component Details</h3>
                    <mat-form-field class="full-width">
                      <mat-label>Component</mat-label>
                      <mat-select
                        formControlName="component"
                        [displayWith]="displayComponentName"
                        (selectionChange)="onComponentChange($event.value, i)"
                        required
                      >
                        <mat-option
                          *ngFor="let option of componentOptions"
                          [value]="option"
                          [disabled]="isComponentSelected(option, i)"
                        >
                          {{ option.name }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                    <mat-form-field class="full-width">
                      <mat-label>Quantity</mat-label>
                      <input
                        matInput
                        type="number"
                        formControlName="allocatedQuantity"
                        placeholder="Enter quantity"
                        required
                      />
                      <mat-error
                        *ngIf="
                          componentControl
                            .get('allocatedQuantity')
                            ?.hasError('min')
                        "
                      >
                        Quantity must be at least 1.
                      </mat-error>
                      <mat-error
                        *ngIf="
                          componentControl
                            .get('allocatedQuantity')
                            ?.hasError('notInteger')
                        "
                      >
                        Quantity must be a whole number.
                      </mat-error>
                    </mat-form-field>
                    <ng-container *ngIf="connectComponentService.isConnectComponent(componentControl)">
                      <mat-form-field class="full-width">
                        <mat-label>Number of Units</mat-label>
                        <input
                          matInput
                          type="number"
                          min="0"
                          formControlName="numberOfUnits"
                          required
                        />
                        <mat-error
                          *ngIf="
                            componentControl
                              .get('numberOfUnits')
                              ?.hasError('min')
                          "
                        >
                          Number of Units cannot be negative.
                        </mat-error>
                      </mat-form-field>
                      <mat-form-field class="full-width">
                        <mat-label>Number of Perimeter/Amenity</mat-label>
                        <input
                          matInput
                          type="number"
                          min="0"
                          formControlName="numberOfPerimeterAmenity"
                          required
                        />
                        <mat-error
                          *ngIf="
                            componentControl
                              .get('numberOfPerimeterAmenity')
                              ?.hasError('min')
                          "
                        >
                          Number of Perimeter/Amenity cannot be negative.
                        </mat-error>
                      </mat-form-field>
                    </ng-container>
                    <div class="component-price">
                      <h4
                        *ngIf="!componentControl.get('useCustomPrice')?.value"
                      >
                        Price per Unit:
                        {{ componentControl.get('component')?.value?.prices?.[0]?.formattedUnitPrice ?? '' }}
                      </h4>
                    </div>
                    <div class="action-buttons">
                      <button
                        mat-button
                        color="primary"
                        (click)="addComponent()"
                      >
                        <mat-icon>add</mat-icon>
                        Add Component
                      </button>
                      <button
                        mat-button
                        color="warn"
                        (click)="removeComponent(i)"
                      >
                        <mat-icon>remove</mat-icon>
                        Remove Component
                      </button>
                    </div>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>
          <div class="price-section">
            <div class="section-header">
              <mat-icon>attach_money</mat-icon>
              <h3>Component Summary</h3>
            </div>
            <div class="price-details">
              <div>
                <h3>Price: ${{ totalPrice }}</h3>
              </div>
              <div *ngFor="let item of selectedComponents; let i = index">
                <h4>
                  {{ item.component.name }}: {{ item.quantity }} x
                  {{
                    components.at(i).get("useCustomPrice")?.value
                      ? components.at(i).get("customPrice")?.value
                      : item.component.prices[0].formattedUnitPrice || "N/A"
                  }}
                </h4>
              </div>
            </div>
          </div>
        </div>
        <div class="bottom-section" [formGroup]="metafieldsGroup">
          <div class="integrator-section">
            <div class="section-header">
              <mat-icon>info_outline</mat-icon>
              <h3>Project Information</h3>
            </div>
            <mat-form-field class="full-width">
              <mat-label
                >What type of project is this?</mat-label
              >
              <mat-select formControlName="projectType" required>
                <mat-option value="competitor_takeover">Competitor Takeover</mat-option>
                <mat-option value="mechanical_upgrade">Mechanical Upgrade</mat-option>
                <mat-option value="new">New Construction</mat-option>
                <mat-option value="not_on_zentra">Not on Zentra</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field class="full-width">
              <mat-label>Is this an Engage Migration?</mat-label>
              <mat-select formControlName="engageMigration" required>
                <mat-option value="yes">Yes</mat-option>
                <mat-option value="no">No</mat-option>
              </mat-select>
            </mat-form-field>
            <div
              *ngIf="metafieldsGroup.get('engageMigration')?.value === 'yes'"
            >
              <mat-form-field class="full-width">
                <mat-label>Expected Migration Start Date</mat-label>
                <mat-datepicker-toggle
                  matPrefix
                  [for]="migrationPicker"
                ></mat-datepicker-toggle>
                <input
                  matInput
                  [matDatepicker]="migrationPicker"
                  formControlName="expectedMigrationDate"
                />
                <mat-datepicker #migrationPicker></mat-datepicker>
                <mat-error
                  *ngIf="
                    metafieldsGroup
                      .get('expectedMigrationDate')
                      ?.hasError('pastDate')
                  "
                >
                  Date cannot be in the past.
                </mat-error>
              </mat-form-field>
              <mat-form-field class="full-width">
                <mat-label>Engage Site Name (if known)</mat-label>
                <input matInput formControlName="engageSiteName" />
              </mat-form-field>
              <mat-form-field class="full-width">
                <mat-label>Engage Site ID (if known)</mat-label>
                <input matInput formControlName="engageSiteId" />
              </mat-form-field>
            </div>
            <mat-form-field class="full-width">
              <mat-label>Expected Occupancy Date</mat-label>
              <mat-datepicker-toggle
                matPrefix
                [for]="occPicker"
              ></mat-datepicker-toggle>
              <input
                matInput
                [matDatepicker]="occPicker"
                formControlName="expectedOccupancyDate"
                required
              />
              <mat-datepicker #occPicker></mat-datepicker>
              <mat-error
                *ngIf="
                  metafieldsGroup
                    .get('expectedOccupancyDate')
                    ?.hasError('pastDate')
                "
              >
                Date cannot be in the past.
              </mat-error>
            </mat-form-field>
            <mat-form-field class="full-width">
              <mat-label>Expected Implementation Start Date</mat-label>
              <mat-datepicker-toggle
                matPrefix
                [for]="implPicker"
              ></mat-datepicker-toggle>
              <input
                matInput
                [matDatepicker]="implPicker"
                formControlName="implementationStartDate"
                required
              />
              <mat-datepicker #implPicker></mat-datepicker>
              <mat-error
                *ngIf="
                  metafieldsGroup
                    .get('implementationStartDate')
                    ?.hasError('pastDate')
                "
              >
                Date cannot be in the past.
              </mat-error>
            </mat-form-field>
          </div>
          <div class="bottom-right-section">
            <div class="purchaser-section">
              <div class="section-header">
                <mat-icon>calendar_month</mat-icon>
                <h3>Property Information</h3>
              </div>
              <mat-form-field class="full-width">
                <mat-label>Property Name/Site Name</mat-label>
                <input
                  matInput
                  formControlName="property_name"
                  maxlength="50"
                />
              </mat-form-field>
              <div class="unknown-address-row">
                <mat-checkbox (change)="onPropertyUnknownToggle($event)">
                  Property address unknown
                </mat-checkbox>
              </div>
              <div *ngIf="!propertyAddressUnknown">
                <div class="address-container">
                  <mat-form-field class="full-width">
                    <mat-label>Address</mat-label>
                    <input
                      matInput
                      formControlName="property_address"
                      (input)="onAddressInput($event)"
                      placeholder="Start Typing Address - include city, state, zip for better filtering"
                      required
                    />
                  </mat-form-field>
                  <div
                    *ngIf="addressSuggestions.length > 0"
                    class="suggestions-container"
                  >
                    <ul>
                      <li class="manual-entry" (click)="enterManualAddress()">
                        <mat-icon class="address-icon">edit</mat-icon>Can't find
                        your address? Type it in
                      </li>
                      <li
                        *ngFor="let suggestion of addressSuggestions"
                        (click)="selectSuggestion(suggestion)"
                      >
                        <mat-icon class="address-icon">location_on</mat-icon
                        >{{ suggestion.address.freeformAddress }}
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="address-row">
                  <mat-form-field class="city-field">
                    <mat-label>City</mat-label>
                    <input matInput formControlName="property_city" numeric />
                    <mat-error
                      *ngIf="
                        customerInfoGroupInt
                          .get('property_city')
                          ?.hasError('nonAlphabetic')
                      "
                    >
                      City name must contain only letters.
                    </mat-error>
                  </mat-form-field>
                  <mat-form-field class="small-field">
                    <mat-label>State</mat-label>
                    <mat-select formControlName="property_state">
                      <mat-optgroup>
                        <mat-option
                          *ngFor="let state of usStates"
                          [value]="state.abbreviation"
                        >
                          {{ state.name }}
                        </mat-option>
                      </mat-optgroup>
                    </mat-select>
                  </mat-form-field>
                  <mat-form-field class="small-field">
                    <mat-label>Zip Code</mat-label>
                    <input matInput formControlName="property_zip" />
                    <mat-error
                      *ngIf="
                        customerInfoGroupInt
                          .get('property_zip')
                          ?.hasError('invalidZipCode')
                      "
                    >
                      Invalid ZIP code.
                    </mat-error>
                  </mat-form-field>
                  <mat-form-field class="small-field">
                    <mat-label>Country</mat-label>
                    <mat-select formControlName="property_country">
                      <mat-option value="US">United States</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
              <div class="two-col-row">
                <mat-form-field>
                  <mat-label>Property Manager First Name</mat-label>
                  <input
                    matInput
                    formControlName="property_manager_f_name"
                    maxlength="25"
                  />
                </mat-form-field>
                <mat-form-field>
                  <mat-label>Property Manager Last Name</mat-label>
                  <input
                    matInput
                    formControlName="property_manager_l_name"
                    maxlength="25"
                  />
                </mat-form-field>
              </div>
              <div class="three-col-row">
                <mat-form-field>
                  <mat-label>Property Manager Email</mat-label>
                  <input matInput formControlName="property_manager_email" />
                  <mat-error
                    *ngIf="
                      customerInfoGroupInt
                        .get('property_manager_email')
                        ?.hasError('invalidEmail')
                    "
                  >
                    Invalid Email format.
                  </mat-error>
                </mat-form-field>
                <mat-form-field>
                  <mat-label>Property Manager Phone</mat-label>
                  <input
                    matInput
                    formControlName="property_manager_phone"
                    appPhoneFormat
                  />
                  <mat-error
                    *ngIf="
                      customerInfoGroupInt
                        .get('property_manager_phone')
                        ?.hasError('invalidPhoneNumber')
                    "
                  >
                    Phone number must be 10 digits long, excluding spaces and
                    symbols.
                  </mat-error>
                </mat-form-field>
                <mat-form-field>
                  <mat-label>Property Website (optional)</mat-label>
                  <input matInput formControlName="propertyWebsite" />
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>
      </form>
    </mat-step>
    <mat-step
      [stepControl]="customerInfoGroupInt"
      [completed]="hasExistingCustomer || customerInfoGroupInt.valid"
    >
      <ng-template matStepLabel>Customer Information</ng-template>

      <!-- Show read-only customer information if customer exists -->
      <div *ngIf="hasExistingCustomer && existingCustomerData">
        <div class="price-section customer-info-card">
          <div class="section-header">
            <h3>Customer Information</h3>
          </div>
          <div class="customer-info-display">
            <h4>Returning Customer Details</h4>
            <div class="info-list">
              <p *ngIf="existingCustomerData.organization">
                <span>Company:</span> {{ existingCustomerData.organization }}
              </p>
              <p>
                <span>Name:</span> {{ existingCustomerData.first_name }}
                {{ existingCustomerData.last_name }}
              </p>
              <p><span>Email:</span> {{ existingCustomerData.email }}</p>
              <p>
                <span>Phone:</span> {{ existingCustomerData.phone || "N/A" }}
              </p>
              <p>
                <span>Address:</span> {{ existingCustomerData.address }},
                {{ existingCustomerData.city }},
                {{ existingCustomerData.state }} {{ existingCustomerData.zip }}
                {{ existingCustomerData.country_name }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <!-- Show editable form if no existing customer -->
      <form
        *ngIf="!hasExistingCustomer"
        [formGroup]="customerInfoGroupInt"
        (click)="markAllControlsTouched()"
      >
        <div class="price-section">
          <div class="section-header">
            <h3>Integrator Information</h3>
          </div>
          <div class="prop-manager-info-row company-row">
            <mat-form-field class="full-width">
              <mat-label>Company Name</mat-label>
              <input
                matInput
                formControlName="integrator_company"
                maxlength="100"
              />
            </mat-form-field>
          </div>
          <div class="prop-manager-info-row">
            <mat-form-field class="full-width">
              <mat-label>Integrator First Name</mat-label>
              <input
                matInput
                formControlName="integrator_f_name"
                maxlength="25"
              />
            </mat-form-field>
            <mat-form-field class="full-width">
              <mat-label>Integrator Last Name</mat-label>
              <input
                matInput
                formControlName="integrator_l_name"
                maxlength="25"
              />
            </mat-form-field>
            <mat-form-field class="full-width">
              <mat-label>Integrator Email</mat-label>
              <input matInput formControlName="integrator_email" />
              <mat-error
                *ngIf="
                  customerInfoGroupInt
                    .get('integrator_email')
                    ?.hasError('invalidEmail')
                "
              >
                Invalid Email format.
              </mat-error>
            </mat-form-field>
            <mat-form-field class="full-width">
              <mat-label>Integrator Phone</mat-label>
              <input
                matInput
                formControlName="integrator_phone"
                appPhoneFormat
              />
              <mat-error
                *ngIf="
                  customerInfoGroupInt
                    .get('integrator_phone')
                    ?.hasError('invalidPhoneNumber')
                "
              >
                Phone number must be 10 digits long, excluding spaces and
                symbols.
              </mat-error>
            </mat-form-field>
          </div>
          <div class="address-row">
            <mat-form-field class="address-field">
              <mat-label>Address</mat-label>
              <input
                matInput
                formControlName="integrator_address"
                (input)="onAddressInput($event)"
                placeholder="Start Typing Address - include city, state, zip for better filtering"
              />
            </mat-form-field>
            <div
              *ngIf="addressSuggestions.length > 0"
              class="suggestions-container"
            >
              <ul>
                <li class="manual-entry" (click)="enterManualAddress()">
                  <mat-icon class="address-icon">edit</mat-icon>Can't find your
                  address? Type it in
                </li>
                <li
                  *ngFor="let suggestion of addressSuggestions"
                  (click)="selectSuggestionInt(suggestion)"
                >
                  <mat-icon class="address-icon">location_on</mat-icon
                  >{{ suggestion.address.freeformAddress }}
                </li>
              </ul>
            </div>
            <mat-form-field class="city-field">
              <mat-label>City</mat-label>
              <input matInput formControlName="integrator_city" numeric />
              <mat-error
                *ngIf="
                  customerInfoGroupInt
                    .get('integrator_city')
                    ?.hasError('nonAlphabetic')
                "
              >
                City name must contain only letters.
              </mat-error>
            </mat-form-field>
            <mat-form-field class="small-field">
              <mat-label>State</mat-label>
              <mat-select formControlName="integrator_state">
                <mat-optgroup>
                  <mat-option
                    *ngFor="let state of usStates"
                    [value]="state.abbreviation"
                  >
                    {{ state.name }}
                  </mat-option>
                </mat-optgroup>
              </mat-select>
            </mat-form-field>
            <mat-form-field class="small-field">
              <mat-label>Zip Code</mat-label>
              <input matInput formControlName="integrator_zip" />
              <mat-error
                *ngIf="
                  customerInfoGroupInt
                    .get('integrator_zip')
                    ?.hasError('invalidZipCode')
                "
              >
                Invalid ZIP code.
              </mat-error>
            </mat-form-field>
            <mat-form-field class="small-field">
              <mat-label>Country</mat-label>
              <mat-select formControlName="integrator_country">
                <mat-option value="US">United States</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </form>
    </mat-step>
    <mat-step [stepControl]="paymentGroup" [completed]="chargifyToken !== ''">
      <div class="payment-group">
        <div>
          <ng-template matStepLabel>Payment Details</ng-template>
          <div class="price-section">
            <div class="section-header">
              <h3>Payment Information</h3>
            </div>
            <div class="same-as">
              <mat-checkbox
                [(ngModel)]="usePropertyDetails"
                (change)="copyPropertyDetailsToChargifyInt()"
              >
                Billing Details Same as Integrator Details?
              </mat-checkbox>
            </div>
            <app-chargify-form
              [usePropertyDetails]="usePropertyDetails"
              #chargifyForm
              [firstName]="billingDetailsGroupInt.get('firstName')?.value"
              [lastName]="billingDetailsGroupInt.get('lastName')?.value"
              [address]="billingDetailsGroupInt.get('address')?.value"
              [city]="billingDetailsGroupInt.get('city')?.value"
              [state]="billingDetailsGroupInt.get('state')?.value"
              [zip]="billingDetailsGroupInt.get('zip')?.value"
              [country]="billingDetailsGroupInt.get('country')?.value"
              (validationSuccess)="onChargifyValidationSuccess()"
              (validationFailure)="onChargifyValidationFailure()"
              (achTermsAcceptedChange)="onAchTermsAcceptedChange($event)"
              (achAgreementComplete)="onAchAgreementComplete($event)"
              (isAchChange)="onPaymentMethodChange($event)"
            ></app-chargify-form>
          </div>
        </div>
        <div
          class="integrator-section"
          [formGroup]="wholesalerGroup"
          *ifPermissions="['Subscription View For GuestPurchaser']"
        >
          <div class="section-header">
            <mat-icon>info_outline</mat-icon>
            <h3>Preferred Wholesaler Partner</h3>
          </div>
          <div class="wholesaler-row">
            @if (wholesalers.length > 1) {
            <mat-form-field class="wholesaler-field">
              <mat-label>Select Wholesaler</mat-label>
              <mat-select
                formControlName="wholesalerUserEmail"
                panelClass="wholesaler-select-panel"
                required
              >
                <mat-select-trigger>
                  @if (selectedWholesaler) {
                  <span class="wholesaler-trigger-company">{{
                    selectedWholesaler.userCompany
                  }}</span>
                  <span class="wholesaler-trigger-meta">
                    &middot; Invited by {{ selectedWholesaler.userFirstName }}
                    {{ selectedWholesaler.userLastName }}</span
                  >
                  }
                </mat-select-trigger>
                @for (ws of wholesalers; track ws.userEmail) {
                <mat-option [value]="ws.userEmail">
                  <div class="wholesaler-option-name">
                    {{ ws.userCompany }}
                  </div>
                  <div class="wholesaler-option-meta">
                    Invited by {{ ws.userFirstName }} {{ ws.userLastName }} ({{
                      ws.userEmail
                    }})
                  </div>
                </mat-option>
                }
              </mat-select>
              <mat-error
                *ngIf="
                  wholesalerGroup
                    .get('wholesalerUserEmail')
                    ?.hasError('required')
                "
              >
                A wholesaler selection is required for Guest Purchasers.
              </mat-error>
            </mat-form-field>
            } @else if (wholesalers.length === 1) {
            <div class="single-wholesaler-box">
              <div class="wholesaler-card">
                <div class="wholesaler-company">
                  <mat-icon>business</mat-icon>
                  <span>{{ wholesalers[0].userCompany }}</span>
                </div>
                <div class="wholesaler-contact">
                  <span class="wholesaler-contact-label">Invited by</span>
                  <div class="wholesaler-contact-item">
                    <mat-icon>person</mat-icon>
                    <span
                      >{{ wholesalers[0].userFirstName }}
                      {{ wholesalers[0].userLastName }}</span
                    >
                  </div>
                  <div class="wholesaler-contact-item">
                    <mat-icon>email</mat-icon>
                    <span>{{ wholesalers[0].userEmail }}</span>
                  </div>
                </div>
              </div>
            </div>
            }
            <mat-form-field class="wholesaler-field">
              <mat-label>Reference PO (Optional)</mat-label>
              <input matInput formControlName="referencePO" />
            </mat-form-field>
          </div>
        </div>
      </div>
    </mat-step>
    <mat-step>
      <ng-template matStepLabel>Summary</ng-template>
      <div class="review-section">
        <div class="top-review-section">
          <div class="review-card-t1">
            <div class="card-header-summary">
              <h3>Subscription Details</h3>
              <button
                mat-button
                class="previousStepButton"
                style="visibility: hidden"
              >
                Edit
              </button>
            </div>
            <div class="card-body-t1">
              <div class="card-item-review">
                <h4>Plan Details:</h4>
                <p>{{ selectedProduct?.product?.name || "N/A" }}</p>
                <div>
                  <div *ngFor="let item of selectedComponents">
                    <p>
                      {{ item.component.name || "N/A" }} - Qty:
                      {{ item.quantity || "N/A" }}
                    </p>
                  </div>
                </div>
                @if (firstFormGroup.get('poNumber')?.value) {
                <h4>PO Number</h4>
                <p>{{ firstFormGroup.get("poNumber")?.value }}</p>
                }
              </div>
            </div>
          </div>
          <div class="review-card-t2">
            <div class="card-header-summary">
              <h3>Property Information</h3>
              <button
                mat-button
                class="previousStepButton"
                (click)="goToStep(1)"
              >
                Edit
              </button>
            </div>
            <div class="card-body">
              <div class="card-item-review">
                <h4>Property Name:</h4>
                <p>
                  {{ metafieldsGroup.get("property_name")?.value || "N/A" }}
                </p>
                <h4>Property Address</h4>
                <p>
                  <ng-container
                    *ngIf="propertyAddressUnknown; else showAddress"
                  >
                    Unknown
                  </ng-container>

                  <ng-template #showAddress>
                    {{ metafieldsGroup.get("property_address")?.value || "N/A"
                    }}<br />
                    {{ metafieldsGroup.get("property_city")?.value || "N/A" }},
                    {{ metafieldsGroup.get("property_state")?.value || "N/A" }}
                    {{ metafieldsGroup.get("property_zip")?.value || "N/A" }}
                    {{
                      metafieldsGroup.get("property_country")?.value || "N/A"
                    }}
                  </ng-template>
                </p>
                <h4>Property Owner Information</h4>
                <p>
                  Name:
                  {{
                    metafieldsGroup.get("property_manager_f_name")?.value ||
                      "N/A"
                  }}
                  {{
                    metafieldsGroup.get("property_manager_l_name")?.value ||
                      "N/A"
                  }}
                </p>
                <p>
                  Email:
                  {{
                    metafieldsGroup.get("property_manager_email")?.value ||
                      "N/A"
                  }}
                </p>
                <p>
                  Phone:
                  {{
                    metafieldsGroup.get("property_manager_phone")?.value ||
                      "N/A"
                  }}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div class="bottom-review-section">
          <div class="review-card-b1">
            <div class="card-header-summary">
              <h3>Payment Details</h3>
              <button
                mat-button
                class="previousStepButton"
                (click)="goToStep(3)"
              >
                Edit
              </button>
            </div>
            <div class="card-body">
              <div class="card-item-review">
                @if (customerInfoGroupInt.get('integrator_company')?.value) {
                <h4>Company</h4>
                <p>
                  {{ customerInfoGroupInt.get("integrator_company")?.value }}
                </p>
                }
                <h4 *ngIf="!isAchSelected()">Payment Type: Credit Card</h4>
                <h4 *ngIf="isAchSelected()">Payment Type: Bank Account</h4>

                <p *ngIf="!isAchSelected()">
                  Credit Card information has been entered and validated.
                </p>
                <p *ngIf="isAchSelected()">
                  Bank Account information has been entered and validated.
                </p>
                <p>
                  Please ensure your payment method is correct before proceeding
                  with the purchase.
                </p>
                <ng-container
                  *ifPermissions="['Subscription View For GuestPurchaser']"
                >
                  <h4>Preferred Wholesaler Partner</h4>
                  <p>{{ getSelectedWholesalerName() }}</p>
                  <ng-container
                    *ngIf="wholesalerGroup.get('referencePO')?.value"
                  >
                    <h4>Reference PO</h4>
                    <p>{{ wholesalerGroup.get("referencePO")?.value }}</p>
                  </ng-container>
                </ng-container>
              </div>
            </div>
          </div>
          <div class="review-card-b2">
            <div class="card-header-summary">
              <h3>Important Date</h3>
              <button
                mat-button
                class="previousStepButton"
                style="visibility: hidden"
              >
                Edit
              </button>
            </div>
            <div class="card-body">
              <!-- Product Name -->
              <div class="card-item-review">
                <h4>Billing Renewal Date:</h4>
                <p>
                  {{
                    !isOneTimeProduct
                      ? billingDate
                        ? (billingDate | date: "MMMM d, y":"UTC")
                        : "N/A"
                      : "Non‑recurring — one time fee"
                  }}
                </p>
                <p>
                  *On this date, the billing system will charge the payment
                  method you have on file for the upcoming subscription period.
                </p>
                <ng-template #oneTimeTpl>
                  <p>Non‑recurring — one time fee</p>
                </ng-template>
              </div>
            </div>
          </div>
        </div>
        <div class="review-card-b2">
          <div class="card-header-summary">
            <h3>Payment Summary</h3>
            <button
              mat-button
              class="previousStepButton"
              (click)="onPreviewInvoiceClick()"
            >
              Preview Invoice
            </button>
          </div>
          <div class="bottom-review-section">
            <div class="card-item-total-price">
              <div class="line-item" *ngFor="let item of lineItems">
                <p>{{ item.componentName || item.productName }}</p>
                <p>Amount: ${{ item.amountInCents / 100 | number: "1.2-2" }}</p>
              </div>
              <div class="total-area">
                <p>Subtotal: ${{ subtotal | number: "1.2-2" }}</p>
                <p>Total Tax: ${{ totalTax | number: "1.2-2" }}</p>
                <p>
                  <strong>Total:${{ total | number: "1.2-2" }}</strong>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="terms-container">
          <mat-checkbox [(ngModel)]="termsAccepted">
            I agree to the
            <a href="https://zentra.co/saas-terms/" target="_blank"
              >Terms and Services</a
            >.
          </mat-checkbox>
        </div>
        <div *ngIf="maxioErrors.length > 0" class="error-section">
          <h4>Errors:</h4>
          <ul>
            <li *ngFor="let error of maxioErrors">{{ error }}</li>
          </ul>
        </div>
      </div>
    </mat-step>
  </mat-horizontal-stepper>
  <div class="stepperControls padding s6 all">
    <button mat-button class="previousStepButton" routerLink="/landing">
      Home
    </button>
    <div class="previous-save-button-container">
      <div class="button-container">
        <button
          mat-button
          class="previousStepButton"
          (click)="goToPreviousStep()"
          [style.visibility]=""
          *ngIf="(stepper?.selectedIndex ?? 0) > 0"
        >
          Previous
        </button>
        <button
          mat-raised-button
          class="nextStepButton"
          (click)="goToNextStep()"
          [disabled]="!isCurrentStepValid()"
          *ngIf="shouldShowNextButton()"
        >
          Next
        </button>
      </div>
      <button
        mat-raised-button
        class="nextStepButton"
        [disabled]="
          !termsAccepted ||
          !isCurrentStepValid() ||
          (isAch && !achTermsAccepted)
        "
        *ngIf="stepper?.selectedIndex === 4"
        (click)="purchaseSubscription()"
      >
        Purchase
      </button>
    </div>
  </div>
</div>
